import App from '@user-components/App.vue'
import i18n from '@user-plugins/i18n/index.js'
import router from '@user-plugins/routes/index.js'
import pinia from '@user-plugins/store/index.js'
import vuetify from '@user-plugins/vuetify/index.js'
import { createApp } from 'vue'

// Force cache busting via build-time injection
if (import.meta.env.DEV) {
    console.log('User App running in development mode')
} else {
    console.log('User App Build Time:', __BUILD_TIME__)
}

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')
